module.exports = __webpack_public_path__ + "static-v-shop/1792141392954/img/brands-desktop.2d52cbb2.png";